import React from "react";
import NumberFormat from "react-number-format";
import { Link, Redirect } from "react-router-dom";
import $ from "jquery";
import { Animated } from "react-animated-css";
import styled from "styled-components";
import MovimientosIcon from "../img/movimientosIcon";
import { checkOrgAndNotLoggedIn, oneLineStyles } from "../utils/generalUtils";
import { estilosProvNew } from "../configProvinciasNew";

const Burgermenu = ({
  menu,
  refsetWrapperRef,
  estadoPlataforma,
  logueado,
  traerMensGrales,
  mensajesSinLeer,
  toggleMenu,
  version,
  volverAPlataforma,
  height,
  size,
}) => {
  const colorProv = estilosProvNew[process.env.REACT_APP_COD_ORGANIZACION].primary;
  const newColorProv = estilosProvNew[process.env.REACT_APP_COD_ORGANIZACION];
  const colorFont =
    estilosProvNew[process.env.REACT_APP_COD_ORGANIZACION].textPrimary;
  const fondoSpan =
    estilosProvNew[process.env.REACT_APP_COD_ORGANIZACION].secondary;
  const isOrgAndNotLoggedIn = checkOrgAndNotLoggedIn(
    ["10", "40", "16", "46", "53", "23", "15", "45", "18", "48", "12", "42"],
    logueado
  );

  const checkNotRequireUser = () => {
    if (isOrgAndNotLoggedIn) return true;

    return logueado;
  };

  const openLoginModal = () => {
    $("#loginModal").modal("show");
  };

  const getItemContent = (item) => {
    let items = {
      movements: (
        <>
          <span className="mr-1 ml-1">
            <MovimientosIcon
              color={
                ["10", "40", "16", "46", "15", "45"].includes(process.env.REACT_APP_COD_ORGANIZACION)
                  ? newColorProv.secondary
                  : colorProv
              }
              width="30px"
              height="30px"
              efecto={false}
            />
          </span>
          Movimientos
        </>
      ),
      myAccount: (
        <>
          <span
            className="iconify  mr-2 ml-2"
            data-width="20px"
            color={
              ["10", "40", "16", "46", "15", "45"].includes(process.env.REACT_APP_COD_ORGANIZACION)
                ? newColorProv.secondary
                : colorProv
            }
            data-icon="bi:person"
            data-inline="false"
          ></span>
          Mi cuenta
        </>
      ),
      wallet: (
        <>
          <span
            color={colorProv}
            className="my-icon iconify mr-1 ml-1"
            data-icon="ion:wallet-outline"
            data-inline="false"
            data-width="25px"
          ></span>
          Billetera
        </>
      )
    };
    return items[item];
  };

  return (
    <>
      <Animated
        style={{ position: "relative", zIndex: "4" }}
        animationIn="fadeIn"
        animationInDuration={320}
        animationOut="fadeOut"
        animationOutDuration={350}
        //animateOnMount={false}
        isVisible={menu}
      >
        <div id="overlay-cont">
          <div id="overlay"></div>
        </div>
      </Animated>

      <div
        className={"collapse navbar-collapse show"}
        id="solapa"
        ref={refsetWrapperRef}
      >
        <div
          className="navbar-nav bg-light slide text-left init-burger"
          id="burgerMenu"
          style={{ width: size > 820 && height > 500 ? "25%" : "65%" }}
        >
          <div
            className={
              " burger-header bg-prov-" +
              process.env.REACT_APP_COD_ORGANIZACION
            }
          >
            <div className={"px-2 text-center text-" + colorFont} style={{ color: colorFont }}>
              <h5 className="mt-2 m-bold" style={oneLineStyles}>
                {estadoPlataforma.nombre ? (
                  <>
                    {estadoPlataforma.nombre} {estadoPlataforma.apellido}
                  </>
                ) : (
                  <>{estadoPlataforma.email?.split("@")[0] ?? ""}</>
                )}
              </h5>
            </div>
            <hr
              className={
                "w-75 mx-auto mb-1 mt-1 bg-prov-" +
                process.env.REACT_APP_COD_ORGANIZACION
              }
            ></hr>
            {logueado && (
              <div className={"text-center text-" + colorFont} style={{ color: colorFont }}>
                <div
                  style={{
                    display: "block",
                    fontSize: "22px",
                    ...oneLineStyles,
                  }}
                >
                  <h6>saldo actual:</h6>
                  <NumberFormat
                    style={{ fontSize: "22px" }}
                    className={"rounded m-heavy text-" + colorFont}
                    value={estadoPlataforma.saldo}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    prefix={"$ "}
                    decimalScale={2}
                    fixedDecimalScale={false}
                    isNumericString={true}
                  />
                </div>
              </div>
            )}
          </div>

          <div className="slide-links ml-2">
            <div className="burgerLinks">
              <div //onClick={toggleMenu}
              >
                <Link to="/home">
                  <div
                    onClick={() => volverAPlataforma()}
                    className="pt-0 pb-0"
                  >
                    <span
                      className="iconify iconoLateral  mr-2 ml-2"
                      data-icon="bytesize:home"
                      data-inline="false"
                      data-width="20px"
                      color={
                        ["10", "40", "16", "46", "15", "45"].includes(
                          process.env.REACT_APP_COD_ORGANIZACION
                        )
                          ? newColorProv.secondary
                          : colorProv
                      }
                    ></span>
                    Inicio
                  </div>
                </Link>
              </div>

              {checkNotRequireUser() ? (
                <div>
                  {logueado ? (
                    <Link to="/consultaBilletera">
                      <div
                        onClick={() => volverAPlataforma()}
                        className="pt-0 pb-0 "
                      >
                        {getItemContent("movements")}
                      </div>
                    </Link>
                  ) : (
                    <DivHover onClick={() => openLoginModal()}>
                      {getItemContent("movements")}
                    </DivHover>
                  )}
                </div>
              ) : (
                <Redirect to="/login" />
              )}

              {process.env.REACT_APP_ENABLE_INGRESO_DINERO === 'true' ? (
                <div>
                  {logueado ? <Link
                    to={
                      process.env.REACT_APP_ENABLE_INGRESO_DINERO === 'true'
                        ? (["20", "50", "23", "53", "12", "42"].includes(process.env.REACT_APP_COD_ORGANIZACION) || estadoPlataforma?.apellido === "MAN-815")
                          ? "/identificadorQRCliente/0"
                          : "/identificadorQRCliente/1"
                        : "/identificadorQRCliente"
                    }
                  >
                    <div
                      onClick={() => volverAPlataforma()}
                      className="pt-0 pb-0"
                    >
                      <span
                        className="iconify iconoLateral mr-2 ml-2"
                        data-icon="ion:wallet-outline"
                        data-width="20px"
                        color={
                          ["10", "40", "16", "46", "15", "45"].includes(
                            process.env.REACT_APP_COD_ORGANIZACION
                          )
                            ? newColorProv.secondary
                            : colorProv
                        }
                        data-inline="false"
                      ></span>
                      Billetera
                    </div>
                  </Link> : <div
                    data-toggle="modal"
                    data-target={"#loginModal"}
                    style={{ cursor: "pointer" }}
                  >
                    {getItemContent("wallet")}
                  </div>}
                </div>
              ) : (
                <div //onClick={toggleMenu}
                >
                  <Link
                    to={
                      process.env.REACT_APP_ENABLE_INGRESO_DINERO
                        ? "/identificadorQRCliente/1"
                        : "/identificadorQRCliente/"
                    }
                  >
                    <div
                      onClick={() => volverAPlataforma()}
                      className="pt-0 pb-0"
                    >
                      <span
                        className="iconify iconoLateral mr-2 ml-2"
                        data-icon="ion:wallet-outline"
                        data-width="20px"
                        color={
                          ["10", "40", "16", "46", "15", "45"].includes(
                            process.env.REACT_APP_COD_ORGANIZACION
                          )
                            ? newColorProv.secondary
                            : colorProv
                        }
                        data-inline="false"
                      ></span>
                      Billetera
                    </div>
                  </Link>
                </div>
              )}

              {checkNotRequireUser() ? (
                <div
                  data-toggle="modal"
                  data-target={
                    isOrgAndNotLoggedIn ? "#loginModal" : "#notiModal"
                  }
                  onClick={() => {
                    !isOrgAndNotLoggedIn && traerMensGrales();
                  }}
                >
                  <DivHover className="pos-rel">
                    <span
                      style={{ verticalAlign: "sub" }}
                      className="iconify mr-2 ml-2"
                      data-icon="bytesize:bell"
                      data-inline="false"
                      data-width="20px"
                      color={
                        ["10", "40", "16", "46", "15", "45"].includes(
                          process.env.REACT_APP_COD_ORGANIZACION
                        )
                          ? newColorProv.secondary
                          : colorProv
                      }
                    ></span>

                    <span>Notificaciones</span>

                    {mensajesSinLeer !== 0 && (
                      <span
                        style={{ left: "110%" }}
                        className="badge badge-danger noti-badge"
                      >
                        {logueado ? mensajesSinLeer : ""}
                      </span>
                    )}
                  </DivHover>
                </div>
              ) : (
                <Redirect to="/login" />
              )}

              <div
                style={{ cursor: "pointer" }}
                id="accordion"
                ayuda="ayuda"
                className="ayuda"
                onClick={(e) => {
                  //toggleMenu();
                  let arrow = $(".help-arrow");
                  if (arrow.hasClass("rotate")) {
                    arrow.removeClass("rotate");
                  } else {
                    arrow.addClass("rotate");
                  }
                }}
              >
                <div
                  className="ayuda"
                  ayuda="ayuda"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  <span
                    ayuda="ayuda"
                    className="iconify mr-2 ml-2"
                    data-icon="bx:bx-help-circle"
                    data-inline="false"
                    data-width="20px"
                    color={
                      ["10", "40", "16", "46", "15", "45"].includes(
                        process.env.REACT_APP_COD_ORGANIZACION
                      )
                        ? newColorProv.secondary
                        : colorProv
                    }
                  ></span>
                  <span ayuda="ayuda" className="ayuda">
                    Ayuda
                  </span>

                  <span
                    ayuda="ayuda"
                    className="iconify help-arrow"
                    data-icon="dashicons:arrow-down-alt2"
                    data-inline="false"
                    data-width="25px"
                    color={
                      ["10", "40", "16", "46", "15", "45"].includes(
                        process.env.REACT_APP_COD_ORGANIZACION
                      )
                        ? newColorProv.secondary
                        : colorProv
                    }
                  ></span>
                </div>

                <div
                  ayuda="ayuda"
                  id="collapseOne"
                  className="collapse p-0"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                >
                  <ul className="ayuda-cont">
                    <li
                      //onClick={toggleMenu}

                      data-toggle="modal"
                      data-target="#faqModal"
                      style={{ marginBottom: "2vh", marginTop: "1.2vh" }}
                    >
                      Preguntas Frecuentes
                    </li>
                    <li
                      //onClick={toggleMenu}

                      data-toggle="modal"
                      data-target="#responsableModal"
                      style={{ marginBottom: "2vh" }}
                    >
                      Juego Responsable
                    </li>
                    <li
                      //onClick={toggleMenu}

                      data-toggle="modal"
                      data-target="#contactoModal"
                      style={{ marginBottom: "2vh" }}
                    >
                      Contacto
                    </li>
                    <li
                      //onClick={toggleMenu}

                      data-toggle="modal"
                      data-target="#usoModal"
                      style={{ marginBottom: "2vh" }}
                    >
                      Uso Plataforma
                    </li>
                    <li
                      //onClick={toggleMenu}

                      data-toggle="modal"
                      data-target="#mediosModal"
                      style={{ marginBottom: "1.2vh" }}
                    >
                      Medios de Pago
                    </li>
                  </ul>
                </div>
              </div>

              {checkNotRequireUser() ? (
                <div>
                  {logueado ? (
                    <Link to="/misDatosPersonales">
                      <div
                        onClick={() => volverAPlataforma()}
                        className="pt-0 pb-0"
                      >
                        {getItemContent("myAccount")}
                      </div>
                    </Link>
                  ) : (
                    <DivHover onClick={() => openLoginModal()}>
                      {getItemContent("myAccount")}
                    </DivHover>
                  )}
                </div>
              ) : (
                <Redirect to="/login" />
              )}

              <div
                style={{ cursor: "pointer" }}
                //onClick={toggleMenu}

                data-toggle="modal"
                data-target="#terminosModal"
              >
                <table>
                  <tbody>
                    <TrHover>
                      <td>
                        <span
                          className="iconify mr-2 ml-2"
                          data-icon="teenyicons:contract-outline"
                          data-inline="false"
                          data-width="18px"
                          color={
                            ["10", "40", "16", "46", "15", "45"].includes(
                              process.env.REACT_APP_COD_ORGANIZACION
                            )
                              ? newColorProv.secondary
                              : colorProv
                          }
                        ></span>
                      </td>
                      <td>Términos y condiciones</td>
                    </TrHover>
                  </tbody>
                </table>
              </div>

              {process.env.REACT_APP_ENABLE_AUTOEXCLUSION === "true" && (
                checkNotRequireUser() ? (
                  <div>
                    {logueado ? (
                      <Link to="/autoexclusion">
                        <div //onClick={toggleMenu}
                        >
                          <span
                            className="iconify mr-2 ml-2 mb-1"
                            data-icon="bx:bx-lock"
                            data-inline="false"
                            data-width="18px"
                            color={
                              ["10", "40", "16", "46", "15", "45"].includes(
                                process.env.REACT_APP_COD_ORGANIZACION
                              )
                                ? newColorProv.secondary
                                : colorProv
                            }
                          >
                            {" "}
                          </span>
                          {["13", "43", "20", "50"].includes(
                            process.env.REACT_APP_COD_ORGANIZACION
                          )
                            ? "Autolimitación"
                            : "Autoexclusión"}{" "}
                        </div>
                      </Link>
                    ) : (
                      <DivHover onClick={() => openLoginModal()}>
                        <span
                          className="iconify mr-2 ml-2 mb-1"
                          data-icon="bx:bx-lock"
                          data-inline="false"
                          data-width="18px"
                          color={
                            ["10", "40", "16", "46", "15", "45"].includes(
                              process.env.REACT_APP_COD_ORGANIZACION
                            )
                              ? newColorProv.secondary
                              : colorProv
                          }
                        >
                          {" "}
                        </span>
                        {["13", "43", "20", "50"].includes(
                          process.env.REACT_APP_COD_ORGANIZACION
                        )
                          ? "Autolimitación"
                          : "Autoexclusión"}{" "}
                      </DivHover>
                    )}
                  </div>
                ) : (
                  <Redirect to="/login" />
                )
              )}

              {checkNotRequireUser() ? (
                <div>
                  {["10", "40", "16", "46", "11", "13", "23", "41", "43", "53", "15", "45", "18", "48"].includes(
                    process.env.REACT_APP_COD_ORGANIZACION
                  ) ? (
                    <></>
                  ) : (
                    <>
                      <span
                        className="iconify mr-2 ml-2 mb-1"
                        data-icon="ic:outline-star-rate"
                        data-inline="false"
                        data-width="18px"
                        color={
                          ["10", "40", "16", "46", "15", "45"].includes(
                            process.env.REACT_APP_COD_ORGANIZACION
                          )
                            ? newColorProv.secondary
                            : colorProv
                        }
                      ></span>
                      <a
                        style={{ cursor: "pointer" }}
                        data-toggle="modal"
                        data-target="#rateModal"
                      >
                        Calificar
                      </a>
                    </>
                  )}
                </div>
              ) : (
                <Redirect to="/" />
              )}
            </div>

            {logueado ? (
              <div
                style={{ cursor: "pointer" }}
                className="salir-cont pl-4 pt-1 pb-1"
              >
                <div
                  className="pt-0 pb-0"
                  data-toggle="modal"
                  data-target="#cerrarSesionModal"
                >
                  <span
                    className="iconify text-danger mr-2 ml-2 mb-1"
                    data-icon="bx:bx-log-out-circle"
                    data-inline="false"
                    data-flip="horizontal"
                    data-width="22px"
                    color={
                      ["10", "40", "16", "46", "15", "45"].includes(
                        process.env.REACT_APP_COD_ORGANIZACION
                      )
                        ? newColorProv.secondary
                        : colorProv
                    }
                  ></span>
                  Salir
                </div>
              </div>
            ) : (
              <>{checkNotRequireUser() ? <></> : <Redirect to="/login" />}</>
            )}

            <div
              className={
                "logo-slide pt-1 pb-1 pl-2 pr-2 bg-prov-" +
                process.env.REACT_APP_COD_ORGANIZACION
              }
            >
              <span className={"text-x-small text-" + colorFont + " mr-3"}>
                Ver: {version}
              </span>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default Burgermenu;

const DivHover = styled.span`
  cursor: pointer;
  width: 100%;
  display: block;
  &:hover {
    color: #0056b3;
  }
`;
const TrHover = styled.span`
  &:hover {
    color: #0056b3;
  }
`;
